import { Directive, EventEmitter, ElementRef, Output, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { of } from 'rxjs/internal/observable/of';

@Directive({
  selector: '[appOnBgImgLoad]'
})
export class OnBgImgLoadDirective implements AfterViewInit {

  @Output() imageLoaded: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: object) {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      of(window.getComputedStyle(this.el.nativeElement).backgroundImage).subscribe((style) => {
        if (style) {
          this.imageLoaded.emit(true);
        }
      });
    }
  }
}
